import { render, staticRenderFns } from "./ModalBuysRelationComponent.vue?vue&type=template&id=5ad7c576&scoped=true"
import script from "./ModalBuysRelationComponent.vue?vue&type=script&lang=js"
export * from "./ModalBuysRelationComponent.vue?vue&type=script&lang=js"
import style0 from "./ModalBuysRelationComponent.vue?vue&type=style&index=0&id=5ad7c576&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad7c576",
  null
  
)

export default component.exports